<template>
  <div class="proportion">
    <div class="row" v-for="(item, index) in dic" :key="index">
      <div class="label" v-text="dic[index].label"></div>
      <el-slider v-model="valueArr[index]" @input="(val)=>inputValue(val,index)" @change="(val)=>changeValue(val,index)" :disabled="disabled" show-input :show-input-controls="false" :show-tooltip="tooltip"></el-slider>
    </div>
    <div class="grey">
      提示：总比重必须为：<span class="blue">{{total}}</span>，已分配比重：<span :class="result&&result.length && result.reduce((prev,cur)=>prev+cur) == total?'green':'red'">{{result&&result.length?result.reduce((prev,cur)=>prev+cur):0}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "proportion",
  props: {
    total: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dic: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    dataType: {
      type: String,
      default: 'array'
    },
    change: Function,
    prop: String,
    skipType: undefined,
    skipValue: String,
    type: String
  },
  data () {
    return {
      result: [],
      valueArr: [],
      tooltip:true
    };
  },
  watch: {
    'value': {
      handler(val) {
        if(!val || !val.length) {
          this.valueArr = this.dic.map(n=>{return n.value})
        }
        if(this.change && typeof(this.change)=='function') this.change({value: val, column: this})
      },
      immediate: true
    },
    'result': {
      handler(val) {
        this.$emit('input', val)
      },
    },
  },
  created () { },
  mounted () { 
  },
  methods: {
    inputValue(val,index) {
       this.tooltip = true
      if(val > 0) {
        this.$set(this.result, index, val)
      }
    },
    changeValue() {
      this.tooltip = false
      let allVal = this.valueArr.reduce((prev,cur)=> {
        if (cur in prev) prev[cur]++
        else prev[cur] = 1
        return prev;
      }, {});
      if(allVal[0] == 1) {
        let last = this.total - this.valueArr.reduce((prev,cur)=>prev+cur)
        this.valueArr.map((item,i)=>{
          if(item==0) {
            this.$set(this.valueArr, i, last )
            this.$set(this.result, i, last )
            }
        })
      }
    }
  }
};
</script>
<style scoped>
.proportion /deep/ .row {
  position: relative;
}
.proportion /deep/ .label {
  position: absolute;
  max-width: 240px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.proportion /deep/ .el-slider__input {
  float: left;
  width: 80px;
  margin-left: 250px;
}
.proportion /deep/ .el-slider__runway.show-input {
  margin-left: 350px;
  margin-right: 10px;
}
.grey {
  color: #909399;
}
.blue {
  color: #409EFF;
}
.green {
  color: #67c23a;
}
.red {
  color: #f56c6c;
}
@media screen and (max-width: 768px) { 
  .proportion /deep/  .label {
    position: relative;
  }
  .proportion /deep/ .el-slider__input {
    margin-left: 0;
  }
  .proportion /deep/ .el-slider__runway.show-input {
    margin-left: 100px;
    margin-right: 10px;
  }
}
</style>